import {sendPasswordResetEmail} from "firebase/auth";
import {auth} from '../config/firebase';

export const sendResetPassword = async (email) => {
  if (!email) throw new Error("Introduce tu email para recuperar la contraseña.");
  await sendPasswordResetEmail(auth, email);
};